module.exports = __webpack_public_path__ + "static/isaac-a5b03a404741ac934eebb2426cdd08cf.svg";